import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_REVENUE_LONGER_COPY_ON_COMBO = defineFcm('revenue_longer_copy_on_combo')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				experimentName: { type: 'string' },
			},
		}),
	)
	.withDefault(undefined)
	.withMerger(({ globalValue, countryValue, localeValue }) => {
		return countryValue ?? localeValue ?? globalValue;
	})
	.toConfig({
		owner: 'squad-koi',
		scope: 'corgi-front-end',
		context: 'Promote or Share Page',
		description: 'Feature config for longer copy on combo',
		mergeLogic: 'Displays in order of country, locale, then global',
		import: false,
		template: {
			experimentName: '__invalid_experiment__',
		},
		deprecated: 'FCM no longer in use — safe to delete after 14 days',
	});
